import React, { Suspense, lazy, useEffect } from "react";
import { Routes, Route } from "react-router-dom";
import "bootstrap/dist/css/bootstrap.min.css";
import { Row, Col, Spinner } from "react-bootstrap";
import Navigation from "./navigation/Navigation";
import AOS from "aos";
import "aos/dist/aos.css";

const Home = lazy(() => import("./pages/Home/index"));
const About = lazy(() => import("./pages/About/index"));
const Services = lazy(() => import("./pages/Services/index"));
const Testimonials = lazy(() => import("./pages/Testimonials/index"));
const Contact = lazy(() => import("./pages/Contact/index"));
const Privacy = lazy(() => import("./pages/Privacy/index"));

const App = () => {
	useEffect(() => {
		AOS.init();
	}, []);

	return (
		<>
			<Navigation />
			<Suspense
				fallback={
					<div
						style={{
							height: "100vh",
							width: "100vw",
							display: "flex",
							alignItems: "center",
							justifyContent: "center",
						}}
					>
						<Spinner animation="grow" variant="info" />
					</div>
				}
			>
				<Routes>
					<Route path="/" element={<Home />} />
					<Route path="/about" element={<About />} />
					<Route path="/services" element={<Services />} />
					<Route path="/testimonials" element={<Testimonials />} />
					<Route path="/contact" element={<Contact />} />
					<Route path="/privacy" element={<Privacy />} />
				</Routes>
			</Suspense>
			<div className="footer">
				<Row>
					<Col>
						© {new Date().getFullYear()} STAT AIR INTERNATIONAL | <a href="/privacy" style={{color: 'inherit', textDecoration: 'underline'}}>Privacy Policy</a>
					</Col>
				</Row>
			</div>
		</>
	);
};

export default App;
